import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];
import { AwardViewAllComponent } from "./award-view-all.component";
routes.push({ path: 'awards-achivements', component: AwardViewAllComponent});

export const AwardRoutingProvider = RouterModule.forRoot(routes, { useHash: true });